"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = require("@emotion/react");
var styled_1 = __importDefault(require("@emotion/styled"));
var react_2 = __importStar(require("react"));
var context_1 = require("./context");
var Icon = styled_1.default.svg(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    right: 10px;\n    margin-left: 5px;\n    cursor: pointer;\n    ", ";\n"], ["\n    position: relative;\n    right: 10px;\n    margin-left: 5px;\n    cursor: pointer;\n    ", ";\n"])), function (props) {
  return props.theme.hideCancelButton && (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            display: none;\n        "], ["\n            display: none;\n        "])));
});
var CancelIcon = function CancelIcon(_a) {
  var _b = _a.width,
    width = _b === void 0 ? 17 : _b,
    _c = _a.height,
    height = _c === void 0 ? 17 : _c,
    setCleared = _a.setCleared;
  var _d = (0, react_2.useContext)(context_1.SearchContext),
    term = _d.term,
    setActiveChannel = _d.setActiveChannel,
    activeChannel = _d.activeChannel;
  return term || activeChannel ? react_2.default.createElement(Icon, {
    className: CancelIcon.className,
    width: width,
    height: height,
    viewBox: "0 0 17 17",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    onClick: function onClick(e) {
      e.stopPropagation();
      e.preventDefault();
      setCleared(true);
      setActiveChannel(undefined);
    }
  }, react_2.default.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    opacity: "0.582730817"
  }, react_2.default.createElement("g", {
    transform: "translate(-300.000000, -150.000000)",
    fill: "#8E8E93",
    fillRule: "nonzero"
  }, react_2.default.createElement("g", {
    transform: "translate(0.000000, 135.000000)"
  }, react_2.default.createElement("g", null, react_2.default.createElement("g", null, react_2.default.createElement("g", {
    transform: "translate(11.000000, 13.000000)"
  }, react_2.default.createElement("g", {
    transform: "translate(289.000000, 2.000000)"
  }, react_2.default.createElement("path", {
    d: "M8.5,0 C3.805875,0 0,3.805875 0,8.5 C0,13.194125 3.805875,17 8.5,17 C13.194125,17 17,13.194125 17,8.5 C17,3.805875 13.194125,0 8.5,0 Z M9.50158333,8.5 C9.50158333,8.5 11.7250417,10.7234583 11.834125,10.8325417 C12.1110833,11.1095 12.1110833,11.557875 11.834125,11.834125 C11.5571667,12.1110833 11.1087917,12.1110833 10.8325417,11.834125 C10.7234583,11.72575 8.5,9.50158333 8.5,9.50158333 C8.5,9.50158333 6.27654167,11.7250417 6.16745833,11.834125 C5.8905,12.1110833 5.442125,12.1110833 5.165875,11.834125 C4.88891667,11.5571667 4.88891667,11.1087917 5.165875,10.8325417 C5.27425,10.7234583 7.49841667,8.5 7.49841667,8.5 C7.49841667,8.5 5.27495833,6.27654167 5.165875,6.16745833 C4.88891667,5.8905 4.88891667,5.442125 5.165875,5.165875 C5.44283333,4.88891667 5.89120833,4.88891667 6.16745833,5.165875 C6.27654167,5.27425 8.5,7.49841667 8.5,7.49841667 C8.5,7.49841667 10.7234583,5.27495833 10.8325417,5.165875 C11.1095,4.88891667 11.557875,4.88891667 11.834125,5.165875 C12.1110833,5.44283333 12.1110833,5.89120833 11.834125,6.16745833 C11.72575,6.27654167 9.50158333,8.5 9.50158333,8.5 Z",
    opacity: "0.75"
  }))))))))) : null;
};
CancelIcon.className = 'giphy-search-bar-cancel';
exports.default = CancelIcon;
var templateObject_1, templateObject_2;